const setAuthToken = (auth_token) => {
  localStorage.setItem(`realesmart.jwt`, auth_token)
}

const clearAuthToken = () => {
  localStorage.removeItem(`realesmart.jwt`)
}

export { setAuthToken, clearAuthToken }